var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{staticClass:"primary white--text",staticStyle:{"font-family":"'Lato', sans-serif","font-weight":"bold"},attrs:{"dense":"","app":"","clippedLeft":""}},[_c('v-toolbar-title',[_vm._v("Member Tree System "+_vm._s(_vm.$store.getters.conferenceName))])],1),_c('v-navigation-drawer',{attrs:{"permanent":"","expand-on-hover":"","app":"","clipped":""}},[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.$store.getters.username)+" ")])],1)],1),_c('v-list',{attrs:{"dense":"","nav":""}},[_vm._l(([
          // {
          //   label: "Medial Plannerからのお知らせ一覧",
          //   link: "/member/info",
          //   icon:"mdi-information-outline"
          // },
          {
            label: 'HOME',
            link: '/member',
            icon: 'mdi-home',
          },
          {
            label: '会員情報管理',
            icon: 'mdi-account-circle',
            list: [
              {
                label: '会員情報',
                link: '/member/user/detail',
              },
              {
                label: 'パスワード変更',
                link: '/member/user/password',
              } ],
          },
          {
            label: this.organizationType + '詳細',
            icon: 'mdi-city',
            link: '/member/conference',
          },
          {
            label: '資格・認定情報',
            icon: 'mdi-certificate',
            link: '/member/qualifications',
          },
          {
            label: this.eventType + '･セミナー一覧',
            icon: 'mdi-school',
            link: '/member/meetings',
          },
          {
            label: '委員会情報',
            icon: 'mdi-account-tie',
            link: '/member/positions',
          },
          {
            label: '理事･役員会情報',
            icon: 'mdi-account-group',
            link: '/member/officers',
          },
          {
            label: '支払情報',
            icon: 'mdi-receipt',
            list: [
              {
                label: '年会費一覧',
                link: '/member/payments/annualFees',
              },
              {
                label: '資格・認定入金一覧',
                link: '/member/payments/qualifications',
              },
              {
                label: 'その他入金一覧',
                link: '/member/payments/etcs',
              } ],
          },
          {
            label: 'クレジットカード登録',
            icon: 'mdi-credit-card',
            link: '/member/creditCard',
          },
          {
            label: 'ログアウト',
            icon: 'mdi-logout',
            action: this.logout,
          } ]),function(ref){
        var label = ref.label;
        var link = ref.link;
        var icon = ref.icon;
        var list = ref.list;
        var action = ref.action;
return [(list)?_c('v-list-group',{key:label,attrs:{"value":false,"prepend-icon":icon,"no-action":""},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-item-title',[_vm._v(_vm._s(label))])]},proxy:true}],null,true)},_vm._l((list),function(ll){return _c('v-list-item',{key:ll.label,attrs:{"link":"","exact":"","to":ll.link},on:{"click":function($event){return _vm.clickAction(ll.action)}}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(ll.label))])],1)],1)}),1):_c('v-list-item',{key:label,attrs:{"link":"","exact":"","to":link},on:{"click":function($event){return _vm.clickAction(action)}}},[(icon)?_c('v-list-item-icon',[_c('v-icon',[_vm._v(_vm._s(icon))])],1):_vm._e(),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(label))])],1)],1)]})],2)],1),_c('v-main',[_c('v-container',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }